import { useQuery } from 'react-query';
import backend from '../backend';

type UsePedidosFiltros = {
  status?: string;
  limit?: number;
  offset?: number;
};

async function buscarPedidos(filtros: UsePedidosFiltros) {
  const response = await backend.get('/pedidos', {
    params: {
      status: filtros.status || undefined,
      limit: filtros.limit ?? 50,
      offset: filtros.offset ?? 0,
    },
  });

  const resultados = response.data?.data?.data || [];

  return Array.isArray(resultados) ? resultados : [];
}

export function usePedidos(filtros: UsePedidosFiltros = {}) {
  const query = useQuery(
    [
      'pedidos',
      filtros.status || null,
      filtros.limit ?? 50,
      filtros.offset ?? 0,
    ],
    () => buscarPedidos(filtros),
  );

  return {
    pedidos: query.data || [],
    loading: query.isLoading || query.isFetching,
    erro: query.error ? 'Erro ao carregar pedidos.' : null,
    recarregar: query.refetch,
  };
}
